import { render, staticRenderFns } from "./TarugoAppointmentModal.vue?vue&type=template&id=b850192e&"
import script from "./TarugoAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./TarugoAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./TarugoAppointmentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports